import { render, staticRenderFns } from "./PremiumCard.vue?vue&type=template&id=d196c79e"
import script from "./PremiumCard.vue?vue&type=script&lang=js"
export * from "./PremiumCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports